export function formatDate(iso) {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(iso));
}

export function formatSyncSummary(summary) {
  if (!summary || typeof summary !== 'object') return null;
  const parts = [];
  if (summary.added) parts.push(`${summary.added} novo(s)`);
  if (summary.updated) parts.push(`${summary.updated} atualizado(s)`);
  if (summary.removed) parts.push(`${summary.removed} removido(s)`);
  return parts.length ? parts.join(', ') : null;
}

export function buildSourceReference(kb) {
  const ingest = kb.configurations?.ingest || {};

  if (kb.source_type === 'url') {
    return ingest.url?.url || kb.source_ref || '—';
  }

  if (kb.source_type === 's3') {
    const bucket = ingest.s3?.bucket;
    const prefix = ingest.s3?.prefix;
    if (bucket) {
      return prefix ? `s3://${bucket}/${prefix}` : `s3://${bucket}`;
    }
    return kb.source_ref || '—';
  }

  if (kb.source_type === 'google_drive') {
    const folderUrl = ingest.google_drive?.folder_url;
    const folderId = ingest.google_drive?.folder_id;
    if (folderUrl) return folderUrl;
    if (folderId) return `https://drive.google.com/drive/folders/${folderId}`;
    return kb.source_ref || '—';
  }

  return kb.source_ref || '—';
}

export function isProcessingStatus(status) {
  return ['pending', 'ingesting', 'syncing'].includes(status);
}

export function fileInSource(file) {
  if (file.in_source === false) {
    return false;
  }
  if (file.is_active === false) {
    return false;
  }
  if (file.status === 'removed') {
    return false;
  }
  return true;
}

export function sortFilesBySourcePresence(files) {
  return [...files].sort((a, b) => {
    const aInSource = fileInSource(a);
    const bInSource = fileInSource(b);
    if (aInSource === bInSource) {
      return 0;
    }
    return aInSource ? -1 : 1;
  });
}

const SOURCE_CHECK_STALE_MS = 24 * 60 * 60 * 1000;

export function isSourceCheckStale(lastSourceCheckAt) {
  if (!lastSourceCheckAt) {
    return true;
  }
  const checkedAt = new Date(lastSourceCheckAt).getTime();
  if (Number.isNaN(checkedAt)) {
    return true;
  }
  return Date.now() - checkedAt > SOURCE_CHECK_STALE_MS;
}
